import React, { FC, useState } from 'react';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { Title } from '../developers/page-components/Title';
import { Dropdown } from 'rsuite';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { ApplicationReviewOperationModal } from './ApplicationReviewOperationModal';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { DropdownDisabledPlaceholder } from '../DropdownDisabledPlaceholder';
import { getListItemValue } from '../../utils/utilities';
import { STATUSES } from '../../views/login/Login';
import clsx from 'clsx';

export const TechnicalReview: FC = () => {
  const { t } = useTranslation();
  const { merchantState: { merchantsLists, applicationData }} = useMerchants();

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const closeModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

  const operationStatus = getListItemValue(applicationData?.operationsStatus, merchantsLists?.applicationOperationsStatuses);

  const handleSelect = ({ name, status }): void => {
    setModalState({
      isOpen: true,
      modalTitle: 'Update operation status',
      backdrop: 'static',
      contentClassName: 'd-block',
      minHeight: 100,
      content: <ApplicationReviewOperationModal name={name} status={status} onClose={closeModal} />
    });
  };

  const isDisabled = !applicationData?.primaryContact?.confirmedUser ||
    applicationData?.statusName?.toUpperCase() === STATUSES.CANCELLED ||
    applicationData?.statusName?.toUpperCase() === STATUSES.DECLINED;

  return (
    <SectionWrapper
      title={t('APPLICATION_DETAILS.LABEL.TECHNICAL_SECTION')}
      sectionAdditionalClass="mb-5 min-height-200"
      loading={false}
      isCardBody
    >
      <div className="d-xl-flex justify-content-between">
        <div className="col-xl-7 mb-5 mb-xl-0">
          {t('APPLICATION_DETAILS.LABEL.TECHNICAL_SECTION_TEXT')}
        </div>

        <div className="save-btn-section">
          <Title title={t('APPLICATION_DETAILS.LABEL.INTEGRATION_STATUS')} additionalClass="mb-2" />
          {
            isDisabled
              ? <DropdownDisabledPlaceholder name={operationStatus || t('APPLICATION_DETAILS.LABEL.INTEGRATION_REVIEW')} />
              : (
                <Dropdown
                  title={operationStatus || t('APPLICATION_DETAILS.LABEL.INTEGRATION_REVIEW')}
                  placement="bottomEnd"
                  data-cy="operations-status-dropdown"
                >
                  {
                    merchantsLists?.applicationOperationsStatuses.map(({ value, label }) => {
                      return (
                        <Dropdown.Item
                          key={value}
                          onClick={(): void => handleSelect({ name: label, status: value })}
                          className={clsx('fw-bolder fs-7', applicationData?.operationsStatus === value ? 'text-black main-font-family' : 'text-muted')}
                        >
                          {label}
                        </Dropdown.Item>
                      );
                    })
                  }
                </Dropdown>
              )
          }
        </div>
      </div>

      <ModalWindow
        {...modalState}
        onClose={closeModal}
      />

    </SectionWrapper>
  );
};